export default __webpack_public_path__ + "static/media/image11.63b1b7d6.svg";